const images = {
  logo: require("../assets/images/logo.png"),
}

export default images
